__turbopack_context__.v({
  "answer": "style-module-scss-module__h1zRxq__answer",
  "answerIcon": "style-module-scss-module__h1zRxq__answerIcon",
  "answerLabel": "style-module-scss-module__h1zRxq__answerLabel",
  "answerSelected": "style-module-scss-module__h1zRxq__answerSelected",
  "answers": "style-module-scss-module__h1zRxq__answers",
  "back": "style-module-scss-module__h1zRxq__back",
  "backIcon": "style-module-scss-module__h1zRxq__backIcon",
  "category": "style-module-scss-module__h1zRxq__category",
  "content": "style-module-scss-module__h1zRxq__content",
  "counter": "style-module-scss-module__h1zRxq__counter",
  "footer": "style-module-scss-module__h1zRxq__footer",
  "footerMeta": "style-module-scss-module__h1zRxq__footerMeta",
  "main": "style-module-scss-module__h1zRxq__main",
  "question": "style-module-scss-module__h1zRxq__question",
  "title": "style-module-scss-module__h1zRxq__title",
  "visual": "style-module-scss-module__h1zRxq__visual",
  "visualImage": "style-module-scss-module__h1zRxq__visualImage",
});
